<template>
  <b-modal ref="modal" v-bind="{...$props, ...$attrs}" v-on="$listeners">
    <template #modal-header>
      <slot name="modal-header"></slot>
    </template>
    <template #modal-footer>
      <slot name="modal-footer"></slot>
    </template>
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    anchor: String
  },
  mounted(){
    if(this.anchor && this.$route.hash == this.anchor){
      this.$refs.modal.show()
    }
  },
  watch: {
    $route: function(newVal, _oldVal){
      if(this.anchor && newVal.hash == this.anchor){
        if (this.$store.state.openModal) return; // avoid more than one modal open at the time
        this.$refs.modal.show();
        this.$store.commit("setOpenModal", true)
      } else { this.$store.commit("setOpenModal", false) }
    }
  }
}
</script>
